import { atom, useRecoilState } from 'recoil';
import { IVideo } from '../shared/types';

const unavailableVideosAtom = atom<Set<IVideo['id']>>({ key: 'unavailable-videos', default: new Set<string>() });

export default function useUnavailableVideos() {
    const [unavailableVideoIds, setUnavailableVideoIds] = useRecoilState(unavailableVideosAtom);

    const setUnavailableVideo = (id: IVideo['id']) => setUnavailableVideoIds((prev) => new Set(prev).add(id));

    return { unavailableVideoIds, setUnavailableVideo };
}
